import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, Checkbox, TextField, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from 'material-table';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useAlert } from 'react-alert';
import _ from 'lodash';
import tokenDecoder from '../../../utils/tokenDecoder';
import CheckIcon from '@material-ui/icons/Check';
import VisibilityIcon from '@material-ui/icons/Visibility';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));


const screenCode = 'PURCHASEORDERAPPROVAL';

export default function PurchaseOrderApprovalListing() {
  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [openDialogForReject, setOpenDialogForReject] = useState(false);
  const [openDialogForApprove, setOpenDialogForApprove] = useState(false);
  const [poApprovalDetails, setPoApprovalDetails] = useState({
    groupID: '0',
    factoryID: '0',
    status: '0',
  });
  const [purchaseOrderApprovalDetails, setPurchaseOrderApprovalDetails] = useState([])
  const [poIDData, setPoIDData] = useState(null);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isApproveEnabled: false,
  });
  const [selectedPurchaseOrders, setSelectedPurchaseOrders] = useState([]);
  let encrypted = "";
  let encryptedgroupID = "";
  let encryptedfactoryID = ""

  const handleClickApprove = (purchaseOrderID) => {
    encrypted = btoa(purchaseOrderID.toString());
    encryptedgroupID = btoa(poApprovalDetails.groupID.toString());
    encryptedfactoryID = btoa(poApprovalDetails.factoryID.toString());
    sessionData();
    navigate('/app/purchaseOrderApproval/approve/' + encrypted + "/" + encryptedgroupID + "/" + encryptedfactoryID, {
      state: { poApprovalDetails }
    });
  }

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    if (poApprovalDetails.groupID > 0) {
      trackPromise(getFactoryByGroupID(poApprovalDetails.groupID));
    }
  }, [poApprovalDetails.groupID]);

  useEffect(() => {
    if (poIDData !== null) {
      trackPromise(getData())
    }
  }, [poIDData]);

  useEffect(() => {
    sessionStorage.removeItem('perchaseOrderApproval-page-search-parameters-id');
  }, []);

  useEffect(() => {
    setPurchaseOrderApprovalDetails([]);
    setSelectedPurchaseOrders([]);
  }, [poApprovalDetails.groupID, poApprovalDetails.factoryID, poApprovalDetails.status]);

  async function getPermissions() {

    const IDdata = JSON.parse(sessionStorage.getItem('perchaseOrderApproval-page-search-parameters-id'));
    const permissions = await authService.getPermissionsByScreen(screenCode);
    const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWPURCHASEORDERAPPROVAL');
    if (!isAuthorized) {
      navigate('/404');
    }

    var isApproveEnabled = permissions.find(p => p.permissionCode == 'PURCHASEORDERAPPROVEBUTTONENABLED');
    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: !!permissions.find(p => p.permissionCode === 'GROUPDROPDOWN'),
      isFactoryFilterEnabled: !!permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN'),
      isApproveEnabled: isApproveEnabled !== undefined,
    });

    const isDefaultLoad = IDdata === null;
    if (isDefaultLoad) {
      setPoApprovalDetails({
        ...poApprovalDetails,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      });
    }
    else {
      setPoApprovalDetails({
        ...poApprovalDetails,
        groupID: IDdata.groupID,
        factoryID: IDdata.factoryID,
        status: IDdata.status
      });
    }
    setPoIDData(IDdata);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoryByGroupID(groupID) {
    var response = await services.getFactoryByGroupID(groupID);
    setFactories(response);
  };

  async function getData() {
    let response = await services.GetPoDetailsforApproval(poApprovalDetails.groupID, poApprovalDetails.factoryID, poApprovalDetails.status);
    if (response.statusCode == "Success") {
      setPurchaseOrderApprovalDetails(response.data);
      setSelectedPurchaseOrders([]);
    }
    else {
      alert.error("No records to display")
    }
  }

  async function ApprovePurchaseOrder(updatedOrders) {
    if (selectedPurchaseOrders.length <= 0) {
      alert.error('Please select Purchase orders');
    }
    else {
      let saveModel = {
        groupID: parseInt(poApprovalDetails.groupID),
        factoryID: parseInt(poApprovalDetails.factoryID),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        poitemList: updatedOrders
      }

      let response = await services.ApprovePurchaseOrders(saveModel);
      if (response.statusCode == "Success") {
        alert.success(response.message);
        setSelectedPurchaseOrders([]);
        trackPromise(getData());
      }
      else {
        alert.error(response.message);
      }
    }
  }

  function clearData() {
    setPoApprovalDetails({
      ...poApprovalDetails,
      groupID: 0,
      factoryID: 0,
      status: 0
    });
    setSelectedPurchaseOrders([]);
  }

  function handleDialogOpenForReject() {
    setOpenDialogForReject(true)
  }
  function handleDialogOpenForAccept() {
    setOpenDialogForApprove(true)
  }
  function handleDialogCloseForReject() {
    setOpenDialogForReject(false)
  }
  function handleDialogCloseForAccept() {
    setOpenDialogForApprove(false)
  }

  const handleApprove = () => {
    setOpenDialogForApprove(false)
    let updatedOrders = selectedPurchaseOrders.map((order) => ({
      ...order,
      status: 2,
    }));
    setSelectedPurchaseOrders(updatedOrders);
    return trackPromise(ApprovePurchaseOrder(updatedOrders));
  };

  const handleReject = () => {
    setOpenDialogForReject(false)
    let updatedOrders = selectedPurchaseOrders.map((order) => ({
      ...order,
      status: 3,
    }));
    setSelectedPurchaseOrders(updatedOrders);
    return trackPromise(ApprovePurchaseOrder(updatedOrders));
  };

  function sessionData() {
    let sessionModel = {
      groupID: poApprovalDetails.groupID,
      factoryID: poApprovalDetails.factoryID,
      status: poApprovalDetails.status
    }
    sessionStorage.setItem(
      'perchaseOrderApproval-page-search-parameters-id', JSON.stringify(sessionModel)
    );
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  const handlePOSelection = (purchaseOrderID) => {
    setSelectedPurchaseOrders((prevSelected) => {
      const isSelected = prevSelected.some(order => order.purchaseOrderID === purchaseOrderID);

      return isSelected
        ? prevSelected.filter(order => order.purchaseOrderID !== purchaseOrderID)
        : [...prevSelected, { purchaseOrderID, status: 1 }];
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const pendingOrders = purchaseOrderApprovalDetails
        .filter(order => order.status === 1)
        .map(order => ({ purchaseOrderID: order.purchaseOrderID, status: 1 }));
      setSelectedPurchaseOrders(pendingOrders);
    } else {
      setSelectedPurchaseOrders([]);
    }
  };

  const isAllSelected = () => {
    const pendingOrders = purchaseOrderApprovalDetails.filter(order => order.status === 1);
    return pendingOrders.length > 0 && selectedPurchaseOrders.length === pendingOrders.length;
  };

  const isIndeterminate = () => {
    const pendingOrders = purchaseOrderApprovalDetails.filter(order => order.status === 1);
    return selectedPurchaseOrders.length > 0 && selectedPurchaseOrders.length < pendingOrders.length;
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setPoApprovalDetails({ ...poApprovalDetails, [name]: value });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
        </Grid>
      </Grid>
    );
  }

  return (
    <Page className={classes.root} title="Purchase Order Approval">
      <LoadingComponent />
      <Container maxWidth={false}>
        <Formik
          initialValues={poApprovalDetails}
          validationSchema={Yup.object({
            groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
            factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
          })}
          onSubmit={getData}
          enableReinitialize
        >
          {({ handleSubmit, errors, touched }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader title={cardTitle('Purchase Order Approval')} />
                <Divider />
                <CardContent style={{ marginBottom: '2rem' }}>
                  <Grid container spacing={3}>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="groupID">
                        Group *
                      </InputLabel>
                      <TextField
                        select
                        name="groupID"
                        value={poApprovalDetails.groupID}
                        onChange={handleChange}
                        error={touched.groupID && Boolean(errors.groupID)}
                        helperText={touched.groupID && errors.groupID}
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        <MenuItem value="0">Select Group</MenuItem>
                        {generateDropDownMenu(groups)}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="factoryID">
                        Factory *
                      </InputLabel>
                      <TextField
                        select
                        name="factoryID"
                        value={poApprovalDetails.factoryID}
                        onChange={handleChange}
                        error={touched.factoryID && Boolean(errors.factoryID)}
                        helperText={touched.factoryID && errors.factoryID}
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        <MenuItem value="0">Select Factory</MenuItem>
                        {generateDropDownMenu(factories)}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="status">
                        Status
                      </InputLabel>
                      <TextField
                        select
                        name="status"
                        value={poApprovalDetails.status}
                        onChange={handleChange}
                        error={touched.status && Boolean(errors.status)}
                        helperText={touched.status && errors.status}
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        <MenuItem value="0">Select Status</MenuItem>
                        <MenuItem value="1">Pending</MenuItem>
                        <MenuItem value="2">Approved</MenuItem>
                        <MenuItem value="3">Reject</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                  <Grid container justify="flex-end" spacing={3}>
                    <Box pr={2} style={{ marginTop: '20px' }}>
                      <Button
                        color="primary"
                        variant="outlined"
                        type="reset"
                        onClick={clearData}
                        size='small'
                      >
                        Clear
                      </Button>
                    </Box>
                    <Box pr={2} style={{ marginTop: '20px' }}>
                      <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        size='small'
                      >
                        {"Search"}
                      </Button>
                    </Box>
                  </Grid>
                </CardContent>
              </Card>
            </form>
          )}
        </Formik>
        {purchaseOrderApprovalDetails.length > 0 ?
          <PerfectScrollbar>
            <MaterialTable
              title="Purchase Order Details"
              columns={[
                {
                  title: (
                    <Checkbox
                      checked={isAllSelected()}
                      indeterminate={isIndeterminate()}
                      onChange={handleSelectAll}
                      disabled={purchaseOrderApprovalDetails.filter(order => order.status === 1).length === 0}
                    />
                  ),
                  field: "selection",
                  render: (rowData) =>
                    rowData.status == 1 ? (
                      <Checkbox
                        checked={selectedPurchaseOrders.some(order => order.purchaseOrderID === rowData.purchaseOrderID)}
                        onChange={() => handlePOSelection(rowData.purchaseOrderID)}
                      />
                    ) : null,
                  sorting: false,
                  width: 60
                },
                { title: "Purchase Order Number", field: "purchaseOrderNumber" },
                { title: "Supplier", field: "supplierName" },
                {
                  title: "Total", field: "total",
                  align: "right",
                  render: (rowData) =>
                    rowData.total
                      ? Number(rowData.total).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })
                      : "0.00"
                },
                {
                  title: 'Status',
                  field: 'status',
                  type: 'string',
                  cellStyle: { textAlign: 'center', paddingLeft: '10px', verticalAlign: 'middle' },
                  headerStyle: { textAlign: 'center', paddingLeft: '40px', verticalAlign: 'middle' },
                  render: rowData => {
                    const statusMap = {
                      1: "Pending",
                      2: "Approved",
                      3: "Rejected",
                      4: "GRN Completed"
                    };

                    const statusText = statusMap[rowData.status] || "Unknown";

                    const getStatusConfig = (status) => {
                      const configs = {
                        'Pending': {
                          bg: '#fff3e0',
                          color: '#e65100',
                          border: '#ffe0b2'
                        },
                        'Approved': {
                          bg: '#e8f5e9',
                          color: '#2e7d32',
                          border: '#c8e6c9'
                        },
                        'Rejected': {
                          bg: '#ffebee',
                          color: '#c62828',
                          border: '#ffcdd2'
                        },
                        'GRN Completed': {
                          bg: '#e3f2fd',
                          color: '#1565c0',
                          border: '#bbdefb'
                        },
                        'Unknown': {
                          bg: '#f5f5f5',
                          color: '#616161',
                          border: '#e0e0e0'
                        }
                      };
                      return configs[status] || configs['Unknown'];
                    };

                    const config = getStatusConfig(statusText);

                    return (
                      <div
                        style={{
                          display: 'inline-block',
                          backgroundColor: config.bg,
                          color: config.color,
                          padding: '4px 10px',
                          borderRadius: '50px',
                          fontWeight: '600',
                          fontSize: '14px',
                          border: `2px solid ${config.border}`,
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)',
                          transition: 'all 0.2s ease',
                          cursor: 'default',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {statusText}
                      </div>
                    );
                  }
                }
              ]}
              data={purchaseOrderApprovalDetails}
              options={{
                actionsColumnIndex: -1,
                defaultGroupOrder: [1],
              }}
              actions={[
                rowData => ({
                  icon: rowData.status == 1 ? CheckIcon : VisibilityIcon,
                  tooltip: rowData.status == 1 ? 'View & Approve' : 'View',
                  onClick: () => handleClickApprove(rowData.purchaseOrderID),
                }),
              ]}
            />
            <Box mt={6} display="flex" justifyContent="flex-end" >
              <Button
                color="primary"
                type="submit"
                variant="contained"
                disabled={!permissionList.isApproveEnabled || selectedPurchaseOrders.length === 0}
                className={classes.colorCancel}
                onClick={() => { handleDialogOpenForReject(); }}
                style={{ marginTop: '-2rem', marginBottom: '2rem', marginRight: '3rem' }}
              >
                Reject
              </Button>
              <Button
                color="primary"
                type="submit"
                variant="contained"
                disabled={!permissionList.isApproveEnabled || selectedPurchaseOrders.length === 0}
                className={classes.colorRecord}
                onClick={() => { handleDialogOpenForAccept(); }}
                style={{ marginTop: '-2rem', marginBottom: '2rem', marginRight: '1rem' }}
              >
                {"Approve"}
              </Button>
              <Dialog open={openDialogForReject} onClose={handleDialogCloseForReject}>
                <DialogTitle>Confirm To Reject</DialogTitle>
                <DialogContent>
                  <DialogContentText>Are you sure you want to reject this?</DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                  <Button onClick={handleReject} color="primary" autoFocus>
                    Yes
                  </Button>
                  <Button onClick={handleDialogCloseForReject} color="primary">
                    No
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog open={openDialogForApprove} onClose={handleDialogCloseForAccept}>
                <DialogTitle>Confirm To Approve</DialogTitle>
                <DialogContent>
                  <DialogContentText>Are you sure you want to approve this?</DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                  <Button onClick={handleApprove} color="primary" autoFocus>
                    Yes
                  </Button>
                  <Button onClick={handleDialogCloseForAccept} color="primary">
                    No
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </PerfectScrollbar>
          : null}
      </Container>
    </Page>
  );
}
